import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="py-8 sm:py-10 px-4 bg-brand-cream" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center" data-id="element-87">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-petrol/10 border border-brand-petrol/20 text-brand-petrol font-semibold text-xs sm:text-sm mb-4" data-id="element-88">
          <span data-id="element-89">🏋️</span>
          <span data-id="element-90">VOLLSTÄNDIGES 6-IN-1 PLANUNGSSYSTEM</span>
        </div>

        <h1 className="text-2xl sm:text-4xl md:text-[2.75rem] font-serif font-bold text-brand-graphite leading-tight mb-3" data-id="element-91">
          Das vollständige professionelle Planungssystem für Functional Trainer
        </h1>

        <p className="text-base sm:text-lg text-brand-graphite/80 leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-92">
          Sparen Sie Stunden bei der Kursplanung, liefern Sie erstklassige
          Trainingseinheiten und arbeiten Sie mit absoluter Sicherheit – ohne
          Trainingspläne, Stundenstrukturen, Übungsbibliotheken und
          Kundenmaterialien von Grund auf neu erstellen zu müssen.
        </p>

        <div className="inline-block bg-brand-gold/20 border-2 border-brand-gold px-4 py-1.5 rounded-lg mb-5" data-id="element-93">
          <p className="font-bold text-brand-petrol text-base sm:text-lg" data-id="element-94">
            🏋️ FUNCTIONAL TRAINER SYSTEM™ — 6-in-1 Planungssystem
          </p>
        </div>

        <div className="mb-5" data-id="element-95">
          <a href="#pricing" className="block cursor-pointer" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/phTJ2BGuC8HHSgGwmrN1nX/ChatGPT-Image-30-jun-2026_-06_30_56-p.m..webp" alt="Functional Trainer System – Vollständiges 6-in-1 Planungssystem" className="w-full h-auto object-contain max-w-md sm:max-w-lg mx-auto hover:scale-105 transition-transform duration-300" data-id="element-97" />
          </a>
        </div>

        <div className="mb-4" data-id="element-98">
          <CTAButton className="max-w-md mx-auto" data-id="element-99">
            🚀 JA! ICH MÖCHTE MEIN SYSTEM JETZT
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-brand-graphite/70" data-id="element-100">
          <div className="flex items-center gap-1" data-id="element-101">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-102" />
            <span className="font-semibold" data-id="element-103">
              4,9/5 – Verifizierte Bewertungen
            </span>
          </div>
          <span className="hidden sm:inline" data-id="element-104">•</span>
          <div className="flex items-center gap-1" data-id="element-105">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-106" />
            <span className="font-semibold" data-id="element-107">7-Tage-Garantie – Null Risiko</span>
          </div>
        </div>
      </div>
    </section>;
}